var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classText,attrs:{"type":"button","data-bs-toggle":"modal","data-bs-target":'#' + _vm.modalName}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }